export enum ValidationErrorType {
  QuotaError = 'QuotaError',
  Mandatory = 'Mandatory',
  SpecificError = 'SpecificError',
  FormatError = 'FormatError',
}
